import { DomHelpers } from '../core/DomHelpers.js';
import { Loc } from '../locales/registry.js';
import { ViewWidgetHelper } from '../view/ViewWidgetHelper.js';

/** Показывает кнопку Apply рядом с anchor и вызывает onApply по клику. */
class ApplyButtonController {
    constructor(host, op = {}) {
        this.host = host;
        this.op = op;
    }
    /** Получение или создание кнопки */
    _getOrCreate() {
        // если есть placeholder в разметке — используем его
        var view = ViewWidgetHelper.closestOnByName(this.host);
        const cls = this.op.className ?? 'im-bt-apply';
        const mask = view?.getUiNotMask() ?? '';
        const sel = `.${cls}${mask}`;
        let btn = this.host.querySelector(sel);
        if (!btn) {
            btn = document.createElement("button");
            btn.type = "button";
            btn.className = cls;
            btn.textContent = Loc.apply;
            DomHelpers.hide(btn);
            this.host.appendChild(btn);
        }
        if (getComputedStyle(btn).position === 'static') {
            btn.style.position = 'absolute'; // координаты будем считать как у jQuery.offset
        }
        return btn;
    }
    /** Показать кнопку рядом с элементом */
    showNear(anchor, onApply) {
        const btn = this._getOrCreate();
        // показать до измерений
        DomHelpers.show(btn);
        const btnW = btn.getBoundingClientRect().width || 80;
        // координаты “как offset()”
        const r = anchor.getBoundingClientRect();
        const topDoc = r.top + window.scrollY - 60;
        const leftDoc = r.left + window.scrollX + r.width - btnW;
        // перевод в координаты offsetParent
        const op = btn.offsetParent;
        const opRect = op ? op.getBoundingClientRect() : { top: 0, left: 0 };
        const opTopDoc = (op ? opRect.top : 0) + window.scrollY;
        const opLeftDoc = (op ? opRect.left : 0) + window.scrollX;
        btn.style.top = `${Math.max(0, topDoc - opTopDoc)}px`;
        btn.style.left = `${Math.max(0, leftDoc - opLeftDoc)}px`;
        // ✅ всегда обновляем обработчик на “последний контекст”
        btn.onclick = () => {
            this.hide();
            onApply?.();
        };
    }
    /** Скрыть кнопку и сбросить обработчик */
    hide() {
        const btn = this._getOrCreate();
        DomHelpers.hide(btn);
        btn.onclick = null;
    }
}

export { ApplyButtonController };
